import React, { Component } from 'react';
import './contact.scss';
import { Button } from 'reactstrap';
import Swal from 'sweetalert2'
import axios from 'axios';
import $ from 'jquery';

class Contact extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      message: '',
      isSumbiting: false
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.sendEmail();
    }
  }

  sendEmail() {
    var name = this.state.name;
    var email = this.state.email;
    var message = this.state.message;

    if (name === '' || email === '' || message === '') {
      Swal('Error', 'Please fill out all fields and try again.', 'error');
      return;
    }

    var url = '';
    if (process.env.NODE_ENV === 'development') {
      url = 'http://localhost:3001/email';
    } else {
      url = '/api/email';
    }

    // If already submitting info don't do anything
    if (this.state.isSumbiting === true) {
      return;
    }

    $('#submit-button').prop('disabled', true);
    $('#submit-button').html('<i class="fa fa-spinner fa-spin"></i> Submitting');
    this.setState({isSumbiting: true});

    var _this = this;

    axios.post(url, {
      apiKey: 'wnk$YMYCTH3yN#5%cyf$SF2Fgy4D^R4dHQ#^5EEJSpON',
      name: name,
      email: email,
      message: message
    })
    .then(function (response) {
      Swal("Success", "Your message has been sent! A member of our team will contact you within 24 hours.", "success");
      _this.refs.nameTextBox.value = "";
      _this.refs.emailTextBox.value = "";
      _this.refs.messageTextBox.value = "";
      _this.setState({name: '', email: '', message: '', isSumbiting: false});
      $('#submit-button').prop('disabled', false);
      $('#submit-button').html('Submit');
    })
    .catch(function (error) {
      Swal("Error", "An error has occured. Please try again later. This error has automatically been logged.", "error");
      _this.setState({isSumbiting: false});
      $('#submit-button').prop('disabled', false);
      $('#submit-button').html('Submit');
    });
  }

  render() {
    return (
      <div className="contact">
        <div className="skew"></div>
        <div className="background"></div>
        <div className="form-holder">
          <div className="form" data-aos="fade-down" data-aos-duration="1000">
            <h3>Contact Us</h3>
            <div className="form-center">
              <p>Enter your information below and one of our respresentives will respond to you as soon as possible</p>
            </div>
            <div className="form-center">
              <input ref="nameTextBox" name="name" type="text" placeholder="Name" onChange={this.handleInputChange} />
            </div>
            <div className="form-center">
              <input ref="emailTextBox" name="email" type="email" placeholder="Email" onChange={this.handleInputChange} />
            </div>
            <div className="form-center">
              <input ref="messageTextBox" name="message" type="text" placeholder="Message" onChange={this.handleInputChange} onKeyPress={this.handleKeyPress} />
            </div>
            <div className="form-center">
              <Button id='submit-button' onClick={this.sendEmail}>Submit</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/contact/contact.js